module.exports = __webpack_public_path__ + "static/img/gxuser.9effcdc3.png";